import {useQuery} from '@apollo/client';
import { useTheme } from '@mui/material/styles';
import get from 'lodash/get';
import React, {Fragment, useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import {useParams} from 'react-router-dom';
import ItemDrawer from '../../components/ItemDrawer';
import DataLoadingAndErrors from '../../fhg/components/DataLoadingAndErrors';
import {formatMessage} from '../../fhg/utils/Utils';
import Operator, {OPERATOR_QUERY} from './Operator';

/**
 * Drawer to navigate to the operators.
 *
 * Reviewed: 3/26/20
 */
export default function Operators() {
   const {id} = useParams();
   const {data, loading, error} = useQuery(OPERATOR_QUERY);
   const [operators, setOperators] = useState([]);
   const theme = useTheme();
   const intl = useIntl();

   /**
    * Set the users from the data in the query.
    */
   useEffect(() => {
      if (!!data) {
         setOperators(get(data, 'operators') || []);
      }
   }, [data]);

   /**
    * Append a "Pending deletion" indicator to an operator's display name when it has a scheduled deletion.
    */
   const getOperatorName = (operator) =>
      operator.pendingDeletionDateTime
         ? `${operator.name} ${formatMessage(intl, 'operator.pendingDeletion.listIndicator', '(Pending deletion)')}`
         : operator.name;

   return (
      <Fragment>
         <DataLoadingAndErrors error={error} isLoading={loading}/>
         <ItemDrawer
            items={operators}
            prefixKey={'operators'}
            uri={'/operator'}
            allowCreate
            backgroundColor={theme.palette.primary.main}
            color={'white'}
            onGetName={getOperatorName}
         />
         <Operator key={`operatorView${id}`}/>
      </Fragment>
   );
}
